const dataset = {
  namespaced: true,
  state: {
    batch_item: {
      tid: 0, //项目编号
      status: 1 //状态
    }
  },
  getters: {
    batch_item: (state) => {
      return state.batch_item;
    }
  },
  mutations: {
    //解析数据，避免在进入页面的时候没有初始化数据 
    restore(state) {
      let oState = JSON.parse(localStorage.getItem('dataset'));
      const item = {
        tid: oState.tid,
        status: oState.status
      }
      state.batch_item = item;
    },
    //更新，tid、status 变化时，操作
    updateBatchItem(state, item) {
      state.batch_item = item;
      localStorage.setItem('dataset', JSON.stringify(state.batch_item));
    },
  },
  breadListRemove(state, obj) {
    let index = state.breadList.indexOf(obj);
    state.routerurls.splice(index + 1);
    sessionStorage.setItem('breadList', state);
  },
  breadListCover(state, list) {
    state.breadList = list;
    sessionStorage.setItem('breadList', list);
  }
}

export default dataset



// WEBPACK FOOTER //
// ./src/store/modules/dataset.js